import { FileHandlerResponse, FileHandlerServiceConfig } from './file-handler-service';

export abstract class BasicFileHandlerService {
	public abstract handleOpenFile(config: FileHandlerServiceConfig): Promise<FileHandlerResponse>;
	public abstract handleSaveFile(fileName: string, config: FileHandlerServiceConfig): Promise<FileHandlerResponse>;
}
